import React, { useEffect, useState } from 'react';

interface BanDetail {
  code?: string;
  reason?: string;
  until?: string | null;
}

const Banned: React.FC = () => {
  const [detail, setDetail] = useState<BanDetail | null>(null);

  useEffect(() => {
    try {
      const raw = sessionStorage.getItem('lomi_ban_detail');
      if (raw) {
        setDetail(JSON.parse(raw) as BanDetail);
      }
    } catch {
      /* fall through */
    }
  }, []);

  const reason = detail?.reason || 'Your account has been suspended.';
  const until = detail?.until ? new Date(detail.until) : null;
  const untilLabel = until ? until.toLocaleString() : 'further notice';

  return (
    <div
      style={{
        minHeight: '100vh',
        background: '#f8fafc',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: 24,
      }}
    >
      <div
        style={{
          maxWidth: 480,
          background: 'white',
          border: '1px solid #fecaca',
          borderRadius: 12,
          padding: 32,
          textAlign: 'center',
          boxShadow: '0 4px 12px rgba(0,0,0,0.04)',
        }}
      >
        <div style={{ fontSize: 48, marginBottom: 12 }}>⛔</div>
        <h1 style={{ fontSize: 22, marginTop: 0, marginBottom: 12, color: '#991b1b' }}>
          Account suspended
        </h1>
        <p style={{ color: '#475569', lineHeight: 1.5, margin: '0 0 16px' }}>{reason}</p>
        <p style={{ color: '#64748b', fontSize: 14, margin: '0 0 24px' }}>
          Suspension lifts: <strong>{untilLabel}</strong>
        </p>
        <div style={{ borderTop: '1px solid #f1f5f9', paddingTop: 16, color: '#64748b', fontSize: 14 }}>
          If you think this is a mistake, contact us at{' '}
          <a href="mailto:info@lomistudy.com" style={{ color: '#4a7c10' }}>
            info@lomistudy.com
          </a>
          .
        </div>
        <button
          onClick={() => {
            localStorage.removeItem('access_token');
            localStorage.removeItem('refresh_token');
            localStorage.removeItem('student_id');
            sessionStorage.removeItem('lomi_ban_detail');
            window.location.href = '/';
          }}
          style={{
            marginTop: 20,
            background: 'transparent',
            border: '1px solid #cbd5e1',
            color: '#475569',
            padding: '8px 18px',
            borderRadius: 6,
            cursor: 'pointer',
          }}
        >
          Sign out
        </button>
      </div>
    </div>
  );
};

export default Banned;
